// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.docfile {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 1.5rem;
    padding: 2rem;
}

.icon {
    width: 20px;
    height: 20px;
    margin-bottom: 0.75rem;
}

.file-name {
  color: #000000;
  text-decoration: none;
  font-weight: bold;
  word-break: break-word;
}

.file-link {
  color: #000000;
  text-decoration: none;
  font-weight: bold;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/css/DocFile.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,4DAA4D;IAC5D,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB","sourcesContent":["\n.docfile {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 1.5rem;\n    padding: 2rem;\n}\n\n.icon {\n    width: 20px;\n    height: 20px;\n    margin-bottom: 0.75rem;\n}\n\n.file-name {\n  color: #000000;\n  text-decoration: none;\n  font-weight: bold;\n  word-break: break-word;\n}\n\n.file-link {\n  color: #000000;\n  text-decoration: none;\n  font-weight: bold;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
